import { products } from './content.js'
import { ArrowIcon } from './ui.jsx'

function ProductVisual({ product }) {
  const { flow } = product
  return (
    <div className={`product-visual visual-${product.key}`}>
      <div className="visual-topline">
        <span>{flow.label}</span>
        <span>PRIVATE BUILD</span>
      </div>
      <div className="flow-line" aria-label={flow.nodes.map((node) => node.name).join(' to ')}>
        {flow.nodes.map((node, index) => (
          <div className="flow-node-wrap" key={node.name}>
            <div className="flow-node">
              <span>{String(index + 1).padStart(2, '0')}</span>
              <strong>{node.name}</strong>
              <small>{node.detail}</small>
            </div>
            {index < flow.nodes.length - 1 && <span className="flow-connector" aria-hidden="true"><i /></span>}
          </div>
        ))}
      </div>
      <div className="visual-footer">
        <span>SettlementOS</span>
        <strong>{flow.module}</strong>
      </div>
    </div>
  )
}

export function Products() {
  return (
    <section className="products section" id="products">
      <div className="shell">
        <div className="section-intro">
          <p className="eyebrow dark">Platform</p>
          <h2>Starting with the paid-API loop.</h2>
          <p>Agent commerce is the beachhead. Issuance supplies the trust base; conversion and vault controls extend the same settlement core.</p>
        </div>
        <div className="product-rows">
          {products.map((product) => (
            <article className="product-row" key={product.key}>
              <div className="product-copy">
                <span className="product-index">{product.index}</span>
                <h3>{product.name}</h3>
                <p>{product.summary}</p>
                <a className="quiet-link dark" href="#demo">{product.cta} <ArrowIcon /></a>
              </div>
              <ProductVisual product={product} />
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
